export { default } from "./getParagraphIsAllSpecialCharacters";
